import React from "react";
import BaseInput from "@reusables/BaseInput";
import BaseDropdown from "@reusables/dropdowns/BaseDropdown";

type ImmutableValueProps = {
    label: string;
    value: string | React.ReactNode;
    type?: "field" | "dropdown" | "custom";
};

export default function ImmutableValue({ label, value, type = "field" }: ImmutableValueProps) {
    if (type === "field" && typeof value == "string") {
        return (
            <div>
                <BaseInput
                    label={label}
                    value={value}
                    disabled
                />
            </div>
        );
    } else if (type === "dropdown" && typeof value == "string") {
        return (
            <BaseDropdown<{ id: number, name: string }>
                label={label}
                options={[
                    {
                        id: 0,
                        name: value
                    }
                ]}
                getter={{
                    key: (opt) => opt.id,
                    label: (opt) => opt.name
                }}
                value={{
                    id: 0,
                    name: value
                }}
                disabled
            />
        );
    } else {
        return <div>
            <p className={`mb-2 font-semibold text-inputs-label-dim`}>
                {label}
            </p>
            <div className={"flex items-center border-solid border-inputs-border-disabled bg-inputs-disabled h-[57px] px-2 rounded-md"}>
                {value}
            </div>
        </div>
    }
}
